import { Link } from "react-router-dom";

// Single checkbox + link gating subscription activation. Linked to the
// public /legal/subscription-terms page. The actual consent record is
// stored server-side via Subscriptions.acceptTerms when the owner clicks
// Activate, so this component only owns the UI state.
export function SubscriptionAgreementCheckbox({
  accepted,
  onChange,
}: {
  accepted: boolean;
  onChange: (v: boolean) => void;
}) {
  return (
    <label className="flex items-start gap-3 cursor-pointer text-sm text-ink-2">
      <input
        type="checkbox"
        checked={accepted}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 w-4 h-4 accent-ink shrink-0"
      />
      <span>
        I have read and accept the{" "}
        <Link
          to="/legal/subscription-terms"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-ink hover:opacity-80"
        >
          subscription terms
        </Link>
        .
      </span>
    </label>
  );
}
